import LessonList from 'components/molecules/lessonList';
import {
  useClassStore,
  useLoaderStore,
  useUserStore,
} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import moment from 'moment';
import React, {useEffect} from 'react';
import {View, useWindowDimensions} from 'react-native';
import {Flows, ScreenName} from 'navigations/Screens';
import {HomeScreenProps} from 'navigations/HomeFlow';
import NavigationHeaderWeb from 'components/organisms/navigationWeb/index.web';
import styleSheet from './styles';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './bigCalendar.css';
import {getCurrentWeek} from 'helpers/getCurrentWeekDatePrototype';
import CalendarView from 'components/molecules/calendarView/index.web';
import {getSize} from 'helpers/getSize';
import {DEVICE_SIZES} from 'rn-responsive-styles';
import {bigCalendarViewConfig} from 'constants/calendarConstants';
import {DeleteTypeId} from 'services/API/ClassApi/ClassApiManager';

const HomeScreen = observer((props: HomeScreenProps) => {
  const classStore = useClassStore();
  const userStore = useUserStore();
  const loaderStore = useLoaderStore();

  const theme = useTheme();
  const styles = styleSheet(theme);
  const width = useWindowDimensions().width;
  let schedule = classStore.lessonList;
  let formattedSchedule = [...schedule];

  const localizer = momentLocalizer(moment);

  const onPressCreateClass = () => {
    props.navigation.push(ScreenName.createClass);
  };

  const onPressJoinToClass = (id: string) => {
    props.navigation.push(ScreenName.conference, {
      id,
      name: classStore.getConferenceNameForId(id),
    });
  };

  useEffect(() => {
    const date = new Date();
    classStore.setCurrentDate(date.toISOString());
    classStore.setWeekNumber(getCurrentWeek());

    const focusListenerCallback = async () => {
      loaderStore.startLoading();

      try {
        await classStore.getClasses();
        classStore.mapAndSetEventListForWeb();
      } finally {
        loaderStore.stopLoading();
      }
    };

    formattedSchedule = getFormattedList();

    props.navigation.addListener('focus', focusListenerCallback);

    return () => {
      props.navigation.removeListener('focus', focusListenerCallback);
    };
  }, []);

  const getFormattedList = () => {
    return schedule
      .map(value => {
        return {
          title: value.title,
          data: value.data.slice(),
        };
      })
      .slice();
  };

  const cancelLesson = async (id: string) => {
    classStore.deleteLesson(id, DeleteTypeId.sessionId);

    setTimeout(async () => {
      loaderStore.startLoading();
      await classStore.getClasses();
      classStore.mapAndSetEventListForWeb();
      loaderStore.stopLoading();
    }, 500);
  };
  const deleteSchedule = (id: string) => {
    classStore.deleteLesson(id, DeleteTypeId.scheduleId);
    setTimeout(async () => {
      loaderStore.startLoading();

      await classStore.getClasses();
      classStore.mapAndSetEventListForWeb();

      loaderStore.stopLoading();
    }, 500);
  };

  const LeftView = (
    <View style={styles.webLeftPart}>
      <CalendarView
        onDayPress={(date: Date) => {
          classStore.setCurrentDate(date.toISOString());
        }}
      />
      <LessonList
        showCreateClass={userStore.isTeacherOrAdmin}
        schedule={formattedSchedule}
        onPressCreateClass={() => {
          onPressCreateClass();
        }}
        onPressJoinToClass={id => {
          onPressJoinToClass(id);
        }}
        onPressCancelButton={id => cancelLesson(id)}
        onPressDeleteButton={id => deleteSchedule(id)}
      />
    </View>
  );

  const RightView = (
    <View style={styles.webRightPart}>
      {width > getSize(DEVICE_SIZES.MEDIUM_DEVICE) ? (
        <Calendar
          localizer={localizer}
          events={classStore.eventList}
          startAccessor="start"
          endAccessor="end"
          views={bigCalendarViewConfig}
          style={styles.bigCalendarSize}></Calendar>
      ) : (
        <></>
      )}
    </View>
  );
  return (
    <View style={styles.flex}>
      <NavigationHeaderWeb activeName={Flows.homeFlow} />
      <View style={styles.webContainer}>
        {LeftView}
        {RightView}
      </View>
    </View>
  );
});

export default HomeScreen;
